/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSeoLinks_item$ref: FragmentReference;
export type PdpRespSeoLinks_item = {|
  +internalBuyLinks: ?$ReadOnlyArray<?{|
    +anchorText: ?string,
    +url: ?string,
  |}>,
  +$refType: PdpRespSeoLinks_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSeoLinks_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "internalBuyLinks",
      "storageKey": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "anchorText",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4b68a57e8adb3294f15b813bd8a82c3a';
module.exports = node;
